<template>
  <div>
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <div class="px-3 pb-3">
      <div class="mb-3" style="font-weight: bold; font-size: 18px">ความพึงพอใจในการให้บริการ</div>
      <div v-if="loading" class="text-xs-center mt-4 pb-5">
        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
      </div>
      <div v-else class="mt-3">
        <div><strong>1. ประเมินบริการติดตั้ง</strong></div>
        <br />
        <div>1.1 การประสานงานของเจ้าหน้าที่ในการนัดหมายติดตั้ง</div>
        <v-radio-group row disabled v-model="score.installation.coordinate">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>
        <div>1.2 ความตรงต่อเวลาและความสุภาพของเจ้าหน้าติดตั้ง</div>
        <v-radio-group row disabled v-model="score.installation.timeAndPolite">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>
        <div>1.3 ความเรียบร้อยและความสะดวกในการใช้งานหลังการติดตั้ง</div>
        <v-radio-group row disabled v-model="score.installation.neatness">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <div>1.4 ความพึงพอใจในการได้รับบริการโดยรวม</div>
        <v-radio-group row disabled v-model="score.installation.complacence">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <br />
        <div><strong>2. ประเมิน PC</strong></div>
        <br />
        <div>2.1 PC ได้นำเสนอข้อมูลสินค้า, ให้ความรู้ความเข้าใจ, ประโยชน์ที่ลูกค้าจะได้รับ</div>
        <v-radio-group disabled row v-model="score.pc.offer">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <div>2.2 ลูกค้าได้รับทราบถึงความแตกต่างของชุดครัวคิงส์เมื่อเทียบกับชุดครัวแบรนด์อื่น</div>
        <v-radio-group disabled row v-model="score.pc.compare">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <div>2.3 ลูกค้าได้รับการแนะนำถึงสิทธิประโยชน์ และโปรโมชั่นการขายต่างๆ</div>
        <v-radio-group disabled row v-model="score.pc.benefit">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>
        <div>2.4 การต้อนรับลูกค้า, กิริยาวาจาและบุคลิกภาพของ PC</div>
        <v-radio-group disabled row v-model="score.pc.welcome">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <div>2.5 การติดตามดูแลเอาใจใส่และตอบข้อสักถามลูกค้าของ PC</div>
        <v-radio-group disabled row v-model="score.pc.care">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <br />
        <div><strong>3. เหตุผลสำคัญที่ลูกค้าตัดสินใจซื้อชุดครัวคิงส์ </strong></div>
        <br />
        <div>3.1 ราคา</div>
        <v-radio-group disabled row v-model="score.importantReason.price">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <div>3.2 ความสวยงาม</div>
        <v-radio-group disabled row v-model="score.importantReason.beautiful">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <div>3.3 คุณสมบัติสินค้า เช่น กันน้ำ, กันปลวก ฯลฯ</div>
        <v-radio-group disabled row v-model="score.importantReason.property">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>
        <div>3.4 โปรโมชั่นส่งเสริมการขาย เข่น ของแถม, ส่วนลด ฯลฯ</div>
        <v-radio-group disabled row v-model="score.importantReason.promotion">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>
        <div>3.5 บริการส่งพร้อมติดตั้งฟรี</div>
        <v-radio-group disabled row v-model="score.importantReason.freeService">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>
        <div>3.6 เชื่อมั่นในแบรนด์คิงส์</div>
        <v-radio-group disabled row v-model="score.importantReason.trustBrain">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>

        <div>3.7 พนักงานขาย (PC)​</div>
        <v-radio-group disabled row v-model="score.importantReason.pc">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>
        <div>3.8 การให้บริการออกแบบครัว​</div>
        <v-radio-group disabled row v-model="score.importantReason.design">
          <v-radio :key="n" v-for="n in 4" :value="n" :label="n.toString()"></v-radio>
        </v-radio-group>
        <br />

        <div>
          <strong>4. ข้อเสนอแนะเพิ่มเติมเพื่อนำไปปรับปรุงคุณภาพการให้บริการ</strong>
        </div>
        <br />
        <v-textarea outlined background-color="white" rows="3" disabled v-model="note"></v-textarea>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    detaildata: {
      type: Object
    }
  },
  data() {
    return {
      data: {},
      loading: false,
      score: null,
      note: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    // Cancel due to get data including order already
    // this.getData()

    if (!this.detaildata.satisfactionstatus) {
      this.$swal.fire({ text: 'ยังไม่มีข้อมูลการประเมินความพึงพอใจ' })
      this.$emit('close')
    } else {
      this.loading = true
      this.score = JSON.parse(this.detaildata.satisfactiondetail)
      this.note = this.detaildata.satisfactionnote
      this.loading = false
    }
  },
  methods: {
    getData() {
      var data = {
        orderid: this.detaildata.id
      }
      api.kingkitchengetTechnicianOrderSatisfaction(data, (err, response) => {
        if (err) {
          this.$emit('close')
        } else {
          this.data = response.data[0]
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/Satisfaction.vue